export var DiscountParams;
(function (DiscountParams) {
    DiscountParams["Discount_Code"] = "discount_code";
    DiscountParams["Gcl_Id"] = "gclid";
    DiscountParams["Utm_AdGroup"] = "utm_adgroup";
    DiscountParams["Utm_AdGroup_Id"] = "utm_adgroupid";
    DiscountParams["Utm_Campaign"] = "utm_campaign";
    DiscountParams["Utm_Campaign_Id"] = "utm_campaignid";
    DiscountParams["Utm_Medium"] = "utm_medium";
    DiscountParams["Utm_Source"] = "utm_source";
    DiscountParams["Utm_Term"] = "utm_term";
    DiscountParams["Keyword"] = "utm_keyword";
})(DiscountParams || (DiscountParams = {}));
export const getDiscountParams = (queryParams) => {
    let optionalFields = [];
    Object.keys(DiscountParams).forEach((key) => {
        const paramKey = DiscountParams[key];
        if (queryParams.get(paramKey)) {
            optionalFields.push({
                fieldName: key.split('_').join(' '),
                content: queryParams.get(paramKey),
                fieldKey: paramKey
            });
        }
    });
    return optionalFields;
};
// SP-1514: the UTM restore rewrites the URL with history.replaceState, which useLocation never sees
export const getParamFieldsFromUrl = () => getDiscountParams(new URLSearchParams(window.location.search));
export const stripHTML = (html) => {
    return html.replace(/<\/?[^>]+(>|$)/g, "");
};
